export default {
  'guide.title1': 'Welcome to join OpenDataLab,',
  'guide.title2': 'After logging in, you can',
  'guide.desc1': 'Download massive datasets for free',
  'guide.desc2': 'Create, upload, and manage datasets',
  'guide.desc3': 'Diversified open-source annotation tools',
  'guide.desc4': 'Real-time feedback to optimize your experience',
  'guide.login': 'Log in now',
  'guide.register': 'First use? {node}',
  'guide.register.node': 'Click to register'
};
